export enum MessageType {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}
